export default "__VITE_ASSET__DboZ7Slc__"